import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'

import { useCreatePostModal } from 'contexts/CreatePostModalContext'

export const CreatePostButton = () => {
  const createPostModalRef = useCreatePostModal()

  return (
    <Pressable
      accessibilityRole='button'
      accessibilityLabel='Create Post Button'
      testID='CreatePostButton'
      onPress={() => createPostModalRef?.current?.present()}
      onLongPress={() => createPostModalRef?.current?.present()}
    >
      <Box
        backgroundColor='v2primary'
        border={{ width: 2, color: 'v2primary' }}
        borderRadius='xl'
        margin={{ top: 'xs', horizontal: 'lg' }}
      >
        <Box margin='sm' align='center'>
          <Icon name='plus' size={42} color='black' />
        </Box>
      </Box>
    </Pressable>
  )
}
